<template>
  <div
    class="card chart-card"
    style="height: 315px; border-radius: 8px; margin-bottom: 20px"
  >
  <!-- style="height: 283px" -->
    <div
      class="d-flex card-header portfolioPerformanceChartTitle"
      style="/*padding-left: 0px*/"
    >
      <h4 class="card-title dashboard-cards-header">Portfolio Performance</h4>
      <div
        style="margin-left: 5px; margin-top: auto; margin-bottom: auto"
        v-tooltip.top-end="toolTipInfo"
      >
        <img src="static/img/graphInfo.svg" class />
      </div>
    </div>
    <!-- <chartjs-line-card :chartData="chartData" :chartOptions="chartOptions">
      <template slot="header">
        <div style="display: flex; justify-content: space-between;">
          <h4 class="card-title dashboard-cards-header">Portfolio Performance</h4>
        </div>
      </template>
    </chartjs-line-card>-->
    <div class="portfolioPerformanceChart">
      <chartjs-line
        :chartData="chartData"
        :chartOptions="chartOptions"
        :style="lineChartStyle"
      >
        <!--style="width:80%;display:block;margin-left:auto;margin-right:auto"-->
      </chartjs-line>
    </div>
  </div>
</template>
<script>
import { vals, formatCurrency } from "../../../util";
import { Select, Option } from "element-ui";
import { ChartjsLineCard } from "src/components/index";
import { mapGetters } from "vuex";
import util from "util";
import _ from "lodash";
import ChartjsLine from "../../Chartjs/ChartjsLine";

const MONTH = "month";
const MONTH_FORMAT = "MMM YYYY";
const YEAR = "year";
const YEAR_FORMAT = "YYYY";
const QUARTER = "quarter";
const QUARTER_FORMAT = "[Q]Q YYYY";

export default {
  name: "portfolioPerformanceByYear",
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    ChartjsLineCard,
    ChartjsLine,
  },
  computed: {
    ...mapGetters("charts", [
      "portfolioROIByMonth",
      "portfolioROIByYear",
      "portfolioPerformanceByYear",
      "portfolioPerformanceByQuarter",
    ]),
    ...mapGetters("user", ["currency"]),
    categoryOptions() {
      // get all of the non-numerical values
      let retval = [];
      retval = _.map(vals.PORTFOLIO.GRAPH_OPTIONS, (v) => {
        let label = _.has(vals.HEADER_MAP, v)
          ? vals.HEADER_MAP[v]
          : _.startCase(v);
        return { label, value: v };
      });
      return _.without(retval, undefined, null);
    },
    chartUnit() {
      const self = this;
      // temp solution: do quarters
      // setup our time tick steps correctly based on data points
      switch (self.dateUnit) {
        case MONTH:
          // return month format
          return {
            tooltipFormat: MONTH_FORMAT,
            round: MONTH,
            unit: MONTH,
            displayFormats: {
              month: MONTH_FORMAT,
            },
          };
        case YEAR:
          // return year format
          return {
            tooltipFormat: YEAR_FORMAT,
            round: YEAR,
            unit: YEAR,
            displayFormats: {
              year: YEAR_FORMAT,
            },
          };
        case QUARTER:
          return {
            tooltipFormat: QUARTER_FORMAT,
            round: QUARTER,
            unit: QUARTER,
            displayFormats: {
              quarter: QUARTER_FORMAT,
            },
          };
        default:
          return {};
      }
    },
    chartData() {
      const self = this;
      let portfolioInfo = self.portfolioPerformanceByQuarter();
      self.dateUnit = QUARTER;
      // let labels = portfolioInfo.time;
      // get unique of both value_t and cost_t
      // if it is too large use years instead
      // if (
      //   portfolioInfo.value_t.length > 24 ||
      //   portfolioInfo.cost_t.length > 24
      // ) {
      //   // do year instead
      //   portfolioInfo = self.portfolioPerformanceByYear();
      //   self.dateUnit = YEAR;
      // }
      let valueData = _.zipWith(
        portfolioInfo.value_t,
        portfolioInfo.value,
        function (x, y) {
          return { x, y };
        }
      );
      let costData = _.zipWith(
        portfolioInfo.cost_t,
        portfolioInfo.cost,
        function (x, y) {
          return { x, y };
        }
      );
      self.dataLength = Math.max(valueData.length, costData.length);
      let data = {
        datasets: [
          {
            label: "Value",
            data: valueData,
            backgroundColor: "#E2E9FF",
            borderColor: "#5445F3",
            fill: true,
            //borderWidth: 1.8
          },
          {
            label: "Cost",
            data: costData,
            backgroundColor: "#5445F3",
            borderColor: "#5445F3",
            fill: false,
            borderDash: [3, 3],
            borderWidth: 0,
          },
        ],
      };
      return data;
    },
    chartOptions() {
      const self = this;
      return {
        maintainAspectRatio: this.aspectRatio,
        tooltips: {
          backgroundColor: "#fff",
          titleFontFamily: "custom-helvetica-bold",
          titleFontColor: "#000",
          bodyFontFamily: "custom-helvetica-bold",
          bodyFontColor: "#000",
          footerFontFamily: "custom-helvetica",
          footerFontSize: 10,
          footerFontColor: "#000",
          footerFontStyle: "lighter",
          callbacks: {
            label: function (toolTipItem, data) {
              return (
                (data.datasets[toolTipItem.datasetIndex].label || "") +
                ": " +
                formatCurrency(
                  data.datasets[toolTipItem.datasetIndex].data[
                    toolTipItem.index
                  ].y || 0,
                  self.currency.ref,
                  0,
                  true
                )
              );
            },
          },
        },
        legend: {
          position: "bottom",
          align: "end",
          display: true,
          labels: {
            boxWidth: 10,
            fontSize: 10,
            fontColor: "#000",
            fontFamily: "custom-helvetica,roboto",
            //usePointStyle: true
          },
        },
        scales: {
          xAxes: [
            {
              type: "time",
              distribution: "series",
              bounds: "ticks",
              time: self.chartUnit,
              ticks: {
                source: "data",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return formatCurrency(value, self.currency.ref, 0);
                },
              },
            },
          ],
        },
      };
    },
    toolTipInfo() {
      // right now just return the default (only) string
      return "Shows consolidated Cost and Value of all investments in your portfolio plotted against every quarter of Invested on date";
    },
    lineChartStyle() {
      return {
        position: "relative",
      };
    },
  },
  data() {
    return {
      category: {
        selected: "initial",
        title: "Time",
      },
      dataLength: 0,
      dateUnit: QUARTER,
    };
  },
  props: {
    aspectRatio: {
      type: Boolean,
      default() {
        return false;
      },
    },
    toolTip: {
      type: String,
      default() {
        return `This chart shows the ROI of your portfolio over time.`;
      },
    },
  },
  mounted() {
    const self = this;
  },
};
</script>
<style >
.portfolioPerformanceChart canvas {
  height: 210px !important;
}
.portfolioPerformanceChart {
  padding: 15px 15px 10px 15px;
}
.portfolioPerformanceChartTitle {
  padding: 15px 15px 0px 10px;
}
</style>